import React from "react"
import clsx from 'clsx'
import Tabs from '../../Tabs/Tabs';

// import ServiceLogBuilderTabs from "../../ServiceLogBuilder/ServiceLogBuilderTabs"
import ServiceLogBuilderTabContent from "../../ServiceLogBuilder/ServiceLogBuilderTabContent"

class ProductFolioItemBuilderServiceRequests extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active_tab: "service-log-general",
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'folio-item-service-logs',
      'tab-pane': true
    })

    return(
      <div className={tabClasses} id="folio-item-service-logs">
        <div className="panel panel-default container">
          <div className="panel-body">
            <Tabs tabs={this.tabs()} />
            {/* <ServiceLogBuilderTabs {...this.state} onChangeActiveTab={this.onChangeActiveTab} embedded={true} /> */}
            <ServiceLogBuilderTabContent {...this.state}
              read_only={true}
              buttons={this.props.buttons}
              new_record={true}
              note_obj={this.props.service_log.note_obj}
              service_log={this.props.service_log}
              errors={this.props.service_log.errors}
              reservation_segment={this.props.reservation_segment}
              onChangeNote={this.props.onChangeServiceLogNote}
              onChangeImageGroup={this.props.onChangeServiceLogImageGroup}
              onChangeFlagged={this.props.onChangeServiceLogFlagged}
              onChangeStartTime={this.props.onChangeStartTime}
              onChangeEndTime={this.props.onChangeEndTime}
              onChangeScheduledAt={this.props.onChangeScheduledAt}
              onChangeSetTimeOpen={this.props.onChangeSetTimeOpen}
              onChangeAssignedTo={this.props.onChangeAssignedTo}
              onChangeRoom={this.props.onChangeRoom}
              onChangeStatus={this.props.onChangeStatus}
              onChangeTextInput={this.props.onChangeTextInput}
              date_format={this.props.dateFormat}
              time_format={this.props.time_format}
             />

          </div>
        </div>
      </div>

    )

  }

  tabs(){
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'service-log-general',
          classes: this.state.active_tab === 'service-log-general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'service-log-notes',
          classes: this.state.active_tab === 'service-log-notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );
  };

  onChangeActiveTab(tab, e) {
    // e.stopPropagation();
    // e.preventDefault();

    this.setState({
      active_tab: tab,
    })
  }
}

export default ProductFolioItemBuilderServiceRequests
